module.exports = __webpack_public_path__ + "static/img/alexander_pictgrid6_800x688.1230a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alexander_pictgrid6_800x688.jpg
// module id = jVqh
// module chunks = 0